import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    color: '#7833FF',

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
  },
  item: {
    maxWidth: 225,
    display: 'flex',
    alignItems: 'flex-start',
  },
  numberBox: {
    marginRight: theme.spacing(2),
    padding: theme.spacing(1),
    color: theme.palette.common.white,
    backgroundColor: '#7833FF',
    borderRadius: theme.shape.borderRadius,
    fontWeight: theme.typography.fontWeightBold,
  },
  icon: {
    margin: theme.spacing(2, 0),
    fontSize: theme.typography.h3.fontSize,

    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(0, 2),
      transform: 'rotate(-90deg)',
    },
  },
}));
